import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { BACKEND_URL } from "../lib/config";

const InfoPointsContext = createContext({ byKey: {}, loading: true });

export function InfoPointsProvider({ children }) {
  const [byKey, setByKey] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${BACKEND_URL}/api/config/infopoints`)
      .then((r) => {
        const map = {};
        (r.data.items || []).forEach((ip) => {
          map[ip.key] = ip;
        });
        setByKey(map);
      })
      .catch(() => setByKey({}))
      .finally(() => setLoading(false));
  }, []);

  return (
    <InfoPointsContext.Provider value={{ byKey, loading }}>
      {children}
    </InfoPointsContext.Provider>
  );
}

export function useInfoPoint(key) {
  const { byKey, loading } = useContext(InfoPointsContext);
  return { data: byKey[key], loading };
}
